module.exports = __webpack_public_path__ + "line-awesome.4d42f5f0c62a8f51e876.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/assets/vendors/line-awesome/fonts/line-awesome.ttf?v=1.1.
// module id = ../../../../../src/assets/vendors/line-awesome/fonts/line-awesome.ttf?v=1.1.
// module chunks = styles